export interface IProps {
    onClose(): void;
    onSuccess?(): void;
    isEmpty: boolean;
}

export enum EAction {
    CREATE = 'create',
}
